import { Expose, Type } from 'class-transformer';
import { DropdownModel } from '../../shared-features/models/dropdown-model';

import { Media } from '../../shared-features/models/media';
import { UserType } from '../../shared-features/enums/user-type.enum';
import { DeliveryNoteType } from '../enums/delivery-note-type.enum';
import { DeliveryNoteVerification } from './delivery-note-verification.model';

export interface DeliveryNoteCaptureLocation {
  latitude: number;
  longitude: number;
  addressTitle: string;
}

export class ShipmentDeliveryNote extends DropdownModel {
  @Expose()
  id: number;

  @Expose()
  referenceNumber: number;

  @Type(() => Media)
  @Expose()
  attachment: Media = new Media();

  @Expose()
  shipment_id: number;

  @Expose()
  updatedByName: string;

  @Expose()
  updatedAt: string;

  @Expose()
  uploadedAt: Date;

  @Expose()
  uploadedByName: string;

  @Expose()
  uploadedByType: UserType;

  @Expose()
  captureLocation: DeliveryNoteCaptureLocation;

  @Expose()
  hardCopyUpdateByName: string;
  @Expose()
  hardCopyUpdatedAt: Date;

  @Expose()
  type: DeliveryNoteType;

  @Expose()
  loadingOrderFileSentToDriver: boolean;

  @Type(() => DeliveryNoteVerification)
  @Expose()
  verification?: DeliveryNoteVerification;

  get dropDownDisplayName(): string {
    return this.referenceNumber.toString();
  }
  get dropDownValue(): Object {
    return this;
  }
}
